/* ============================================================================
   Weight MIS Center — the "MIS Upload" tab of the Weight Ledger page.
   Feedback item A2 — two clearly-labelled sub-tabs on one page:
     • Courier MIS Upload   → posts /finance/courierMIS/upload  (COURIER_MIS_UPLOAD)
     • Merchant MIS Upload  → posts /weight/ledger/mis/upload   (WEIGHT_LEDGER_MIS_UPLOAD)
   Each sub-tab reuses its existing upload component, which carries its own
   "Download sample" button and update-frequency help (item A3).

   Uses local state (NOT useTabParam) so it can nest inside the Weight Ledger
   page's own ?tab= driven tabs without clobbering that URL param.
   ========================================================================== */
import { useState } from 'react';
import PillFilters from '../AppointmentDeliveriesV2/shared/PillFilters';
import CourierMisUpload from '../Weight Discrepancy/MisUpload';
import MerchantMisUpload from './MisUpload';

const PILLS = [
    { key: 'courier', label: 'Courier MIS Upload' },
    { key: 'merchant', label: 'Merchant MIS Upload' },
];

function WeightMisCenter() {
    const [view, setView] = useState('courier');
    return (
        <>
            <PillFilters pills={PILLS} value={view} onChange={setView} />
            {view === 'courier' && <CourierMisUpload />}
            {view === 'merchant' && <MerchantMisUpload />}
        </>
    );
}

export default WeightMisCenter;
